<template>
  <div>
    <div style='padding: 15px'>
      <a-form layout='inline'>
        <a-row :gutter='24'>
          <a-col :md='6' :sm='6'>
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'depositDate')" :labelCol='{span:6}'
                         :wrapperCol='{span: 14 , offset:1}'>
              <a-range-picker
                style='width: 240px'
                v-model='queryParam.dateDt'
                format='YYYY-MM-DD' />
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='6'>
<!--            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'callStatus')">-->
<!--              <a-select default-value='0' style='width: 120px' v-model='queryParam.telStatus'>-->
<!--                <a-select value='0'>未拨打</a-select>-->
<!--                <a-select value='1'>已接通</a-select>-->
<!--                <a-select value='2'>未接通</a-select>-->
<!--              </a-select>-->
<!--            </a-form-item>-->
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'callStatus')">
              <dict-select
                style='width: 200px'
                v-model='queryParam.telStatus'
                :dict-code='DICT_CODE.TelMarket_Status'
                :begin="[{ value: '', label: '全部', labelEn: 'All',labelTi: 'ทั้งหมด' }]"
                :placeholder="$t('select')"
              />
            </a-form-item>
          </a-col>

          <a-col :md='6' :sm='6'>
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'telemarketerName')">
              <a-select
                style='width: fit-content; min-width: 200px;'
                v-model='queryParam.userIds'
                mode='multiple'
              >
                <a-select-option v-for='item in userNameList' :key='item.userId'>
                  {{ item.userName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='6'>
            <a-button type='primary' @click='searchCollectionTelMarketInfos' icon='search' style='margin-left: 8px'>
              {{ $t('search') }}
            </a-button>
            <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset') }}
            </a-button>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref='table'
        size='middle'
        :columns='columns'
        :data-source='dataSource'
        :loading='loading'
        :pagination='ipagination'
        bordered
        @change='handleTableChange'
      >
        <Dict slot='telStatusSlot' slot-scope='text' :dict-code='DICT_CODE.TelMarket_Status' :value='text' />

      </a-table>
    </div>
  </div>

</template>

<script>
import { getUserNamelist, queryTelMarketList } from '@/webpublicapi/collection'
import moment from 'moment'
import DictSelect from '../modules/DictSelect'
import Dict from '@/views/webpublic/modules/Dict.vue'
import { getTelUserNamelist } from '@/webpublicapi/group'

const I18N_KEY = {
  COLLECTION: 'collection.'
}

export default {
  name: 'CollectionTelMarket'
  ,
  components: { Dict, DictSelect },
  data() {
    return {
      I18N_KEY,
      loading: false,
      // 分页参数
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      userNameList:[],
      //查询条件
      queryParam: {
        userIds: [],
        dateDt: [moment().add('days', -0), moment().add('days', 0)],
        telStatus: '',
      }


      //回显内容
      , dataSource: []
    }
  }

  , computed: {
    columns() {
      return [
        //title
        {
          title: this.$t(I18N_KEY.COLLECTION + 'depositDate'),
          align: 'left',
          dataIndex: 'createTime'
        },
        {
          title: this.$t(I18N_KEY.COLLECTION + 'telemarketerName'),
          align: 'left',
          dataIndex: 'userName'
        },
        {
          title: this.$t(I18N_KEY.COLLECTION +'dialNumber'),
          align: 'left',
          dataIndex: 'mobileNo'
        },
        {
          title: this.$t(I18N_KEY.COLLECTION +'dialDate'),
          align: 'left',
          dataIndex: 'telTime'
        },
        {
          title: this.$t(I18N_KEY.COLLECTION + 'callStatus'),
          align: 'left',
          dataIndex: 'telStatus',
          scopedSlots: { customRender: 'telStatusSlot' }

        }
      ]
    }
  }
  //初始化方法
  , created() {
    this.loadData(1)
    getTelUserNamelist().then(res => {
      console.log('res',res.data)
      this.userNameList = res.data || []
    })
  }
  //自定义方法
  , methods: {
    //初始化参数
    getQueryParams() {
      console.log('queryParam',this.queryParam)
      const { dateDt } = this.queryParam

      const data = {
        ...this.queryParam,
        createTimeStart: dateDt && this.transformTime(dateDt[0]),
        createTimeEnd: dateDt && this.transformTime(dateDt[1])
      }
      console.log('data',data)
      delete data.dateDt
      data.pageNum = this.ipagination.current
      data.pageSize = this.ipagination.pageSize
      data.telStatus = this.queryParam.telStatus
      data.userIds = this.queryParam.userIds
      console.log('传给后端的数据',data)
      return data
    },
    //格式化日期
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    //重置查询条件
    searchReset() {
      var that = this
      that.queryParam.telStatus = ''
      that.queryParam.dateDt = [moment().add('days', -0), moment().add('days', 0)]
      that.queryParam.userIds=[]
      that.loadData()
    },

    //查询列表方法
    searchCollectionTelMarketInfos() {
      console.log('查询电销信息列表')
      this.loadData(1)
    },
    loadData(arg) {
      //默认加载首页数据
      if (arg === 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      var params = this.getQueryParams()
      queryTelMarketList(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.ipagination.total = res.data.total
          this.dataSource = res.data.rows
        } else {
          this.ipagination.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    handleTableChange(pagination) {
      this.ipagination = pagination
      this.loadData()
    }
  }
}
</script>


<style scoped lang='less'>
@import "~@/assets/less/common.less";
</style>